module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-cart c-cart--size js-size",
    class: {
      'c-cart--open': _vm.sizeGuideOpen
    }
  }, [_c('a', {
    staticClass: "c-cart__header",
    attrs: {
      "id": "ring-size",
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.closeSizeGuide($event)
      }
    }
  }, [_c('span', {
    staticClass: "c-cart__headerText"
  }, [_vm._v("Size guide")]), _vm._v(" "), _c('span', {
    staticClass: "c-cart__headerText"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__text"
  }, [_c('p', [_vm._v("Because we make each ring individually, you can order the exact size you require. If you are unsure of your size, your best option is to go to a local jewellery and ask them to size your finger. Feel free to specify a different size by selecting \"Custom\" from the size dropdown.")]), _vm._v(" "), _c('p', [_vm._v("We work in US and letter sizing and our most popular sizes are 5.5 (small), 7 (medium), 8.5 (large).")]), _vm._v(" "), _c('p', [_vm._v("Alternatively you can measure your finger and use our calculator. If your knuckle is (a lot) larger than the base of your finger then measure your knuckle as well and choose a size between the two. In most cases this shouldn't be an issue.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "c-cart__finger-display"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/measure-size.png"),
      "height": "150",
      "loading": "lazy",
      "alt": "person measuring finger with paper"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-field c-form--contact"
  }, [_c('label', {
    staticClass: "c-field__label",
    attrs: {
      "for": "RingSizeMM"
    }
  }, [_vm._v("Finger circumference (mm)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ringSizeMM),
      expression: "ringSizeMM"
    }],
    staticClass: "c-field__input",
    attrs: {
      "name": "RingSizeMM",
      "type": "number",
      "placeholder": "60mm"
    },
    domProps: {
      "value": (_vm.ringSizeMM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ringSizeMM = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cart__size-result"
  }, [_vm._v("\n                    " + _vm._s(_vm.calculatorResult) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-cart__totals"
  }, [_c('a', {
    staticClass: "c-btn c-btn__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        _vm.closeSizeGuide($event)
      }
    }
  }, [_vm._v("Continue shopping")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('p', [_vm._v("Cut a strip of paper or a thin string at least 8 cm. Or use measuring tape.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Wrap it around your ring finger at the base of the finger joint.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Using a pen or pencil, mark where the ends overlap.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Lay it flat and use a ruler to measure the length in millimeters (MM).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69edfeb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RingSize.vue
// module id = 398
// module chunks = 0